import '../styles/form.css';
import { useState, useEffect, useRef } from 'react';
import 'react-phone-input-2/lib/style.css';
import apiService from '../services/api.service';
import Message from './message';
import Input from './input';
import brands from '../brands.json';
import { FiCopy, FiHome } from 'react-icons/fi';


import { validateForm } from '../utils/validation';
import { getBrand, getHomePageUrl, getArabicName, getLogoPath, getFormMeta } from "../brandResolver";


const DynamicForm = ({ formType, fields, title, introText, banner, terms }) => {
  
  const brand = getBrand();
  const homePage = getHomePageUrl(brand);
  const brandArabic = getArabicName(brand);
  const brandWarranty = brands[brand].warranty;
  const formMeta = getFormMeta(formType, brand);
  const fileInputRef = useRef(null); // Create a ref for file input
  const initialFormData = fields.reduce((acc, field) => {
    acc[field.id] = field.type === 'file' ? null : '';
    if (field.type === 'phone') {
      acc['countryCode'] = '+966';
      acc['mobile'] = '+966'; // Set mobile field to the default country code

    }
    return acc;
  }, {});
  title = formType === 'Ambassadors' || formType === 'Warranty' ?` ${title} ${brandArabic}`: title
  const [formData, setFormData] = useState(initialFormData);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isCopied, setIsCopied] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);

  useEffect(() => {
    document.title = title;
  const logoPath = getLogoPath(brand);

  let favicon = document.querySelector("link[rel~='icon']");

  if (!favicon) {
    favicon = document.createElement("link");
    favicon.rel = "icon";
    document.head.appendChild(favicon);
  }

  favicon.href = logoPath;

  let description = document.querySelector('meta[name="description"]');

  if (!description) {
    description = document.createElement("meta");
    description.name = "description";
    document.head.appendChild(description);
  }

  description.content = formMeta.description || "";
}, [brand, formType, title]);

  const handleInputChange = (e) => {
    const { id, value, type, files } = e.target;
  
    // Check if the id corresponds to a social media platform
    const socialMediaPlatforms = ['facebook', 'x', 'instagram', 'tiktok', 'snapchat'];
  
    if (socialMediaPlatforms.includes(id)) {
      // If it's a social media platform, save it under 'socialMediaAccount'
      setFormData({
        ...formData,
        socialMediaAccount: value, // Save the value as socialMediaAccount
      });
    } else {
      // For other inputs (like file, text, etc.), proceed as usual
    if (type === 'file' && files) {
      const file = files[0];

      // Check if the file size exceeds 200 KB
      if (file.size > 200 * 1024) {
        setErrorMessage("حجم الملف يجب ألا يزيد عن 200 كيلوبايت" );
        return; // Prevent further processing
      } 
      

      // Handle file input separately
      setFormData({
        ...formData,
        [id]: file, // Save the first selected file
      });
      } else {
        // Handle regular inputs (text, phone, etc.)
        setFormData({
          ...formData,
          [id]: value,
        });
      }
    }
  };
  

  const handlePhoneChange = (value, countryData) => {
    setFormData({
      ...formData,
      mobile: value,
      countryCode: countryData.countryCode,
    });
  };

  
 
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (terms && !termsAccepted) {
  setErrorMessage('يرجى الموافقة على الشروط والأحكام');
  return;
}
    setErrorMessage('');
    setSuccessMessage('');
    setIsLoading(true);
    console.log('formData: ',formData)
    const errors = validateForm(fields, formData);
    if (Object.keys(errors).length > 0) {
      setErrorMessage(errors);
      setIsLoading(false);
      return;
    }

    try {
      const formDataToSend = { ...formData, formType, brand };
      const fileField = Object.keys(formData).find((key) => formData[key] instanceof File);

      if (fileField) {
        const uploadFormData = new FormData();
        uploadFormData.append('file', formData[fileField]);

        console.log(`Uploading file for: ${fileField}`);
        const uploadResponse = await apiService.uploadFiles(uploadFormData);

        if (uploadResponse?.data?.url) {
          const urlKey = `${fileField}Url`; // Dynamically create the key for the file URL
          formDataToSend[urlKey] = uploadResponse.data.url; // Assign the uploaded URL
        } else {
          throw new Error('File upload failed');
        }
      }

      await apiService.submitFormData(formDataToSend); // Unified API call
      setSuccessMessage('تم إرسال البيانات بنجاح!');
      setFormData(initialFormData);
      // Reset the file input manually
      if (fileInputRef.current) {
        fileInputRef.current.value = ''; // Reset file input value
      }
       // Wait for 3 seconds and redirect to the external homepage
       if (formType !== 'Customer') {
        setTimeout(() => {
          window.location.href = homePage;
        }, 3000);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      if (error?.status === 409) {
        setErrorMessage('رقم الجوال مسجل مسبقاً');
      } else {
        setErrorMessage('حدث خطأ أثناء إرسال البيانات. يرجى المحاولة مرة أخرى.');
      }
    } finally {
      setIsLoading(false);
    }
  };
  const handleCopyFormUrl = async () => {
  try {
    await navigator.clipboard.writeText(window.location.href);
    setIsCopied(true);

    setTimeout(() => {
      setIsCopied(false);
    }, 2000);
  } catch (error) {
    console.error('Failed to copy form URL:', error);
  }
};
  console.log(' intro: ', introText)
   // Replace {brand} in introText with the actual brand
   const formattedIntroText = introText
   ? introText.replace(/{brand}/g, brandArabic).replace(/{brandWarranty}/g,brandWarranty) // This will replace all instances of {brand}
   : '';
  const isCustomerSubmitted = Boolean(successMessage && formType === 'Customer');
  return (
    <div className="form-wrapper">
       {!(isCustomerSubmitted) && (
        <>
      {banner && (
    <img
      src={banner}
      alt=""
      className="form-banner"
    />
  )}
      <h4 className="form-title">{title}</h4>
      {
        formattedIntroText && <div className="enhanced-title-border">
        <span className="circle"></span>
      </div>
      }
      {formattedIntroText && (
        <div className={`intro-text ${formType === 'Warranty' ? 'center-text' : ''}`}>
        {formattedIntroText.split('\n').map((line, index) => {
            // Check if the line starts with a bullet point
            if (line.trim().startsWith('•')) {
              return (
                <ul key={index}>
                  <li>{line.replace('•', '').trim()}</li> {/* Remove bullet and render as list item */}
                </ul>
              );
            }

            // Otherwise render as regular paragraph
            return <p key={index}>{line}</p>;
          })}
        </div>
      )}
      </>)}
       
        <form onSubmit={handleSubmit} className="form-container">
        {!(isCustomerSubmitted) &&
  fields.map((field) => {
    if (field.dependentOn) {
      const dependentValue = formData[field.dependentOn];

      if (!field.dependencyValues.includes(dependentValue)) {
        return null;
      }
    }

    return (
      <Input
        key={field.id}
        type={field.type}
        id={field.id}
        value={
          field.type === 'social-media'
            ? formData.socialMediaAccount || ''
            : formData[field.id] || ''
        }
        onChange={
          field.type === 'phone'
            ? handlePhoneChange
            : handleInputChange
        }
        placeholder={field.placeholder}
        options={field.options}
        acceptFiles={field.acceptFiles}
        required={field.required}
        ref={field.type === 'file' ? fileInputRef : null}
        min={field.min}
        max={field.max}
      />
    );
  })}
        <Message messageType="error" messageText={errorMessage} />
       {isCustomerSubmitted ? (
  <div className="share-section">
    <p>
      <strong>
      فرصتك للربح تسجّلت واسمك صار له مكان!
      </strong><br />
      شاركها مع اللي يحبهم قلبك وخلّي حظوظك تكبر
    </p>

    <button type="button" onClick={handleCopyFormUrl}>
      <FiCopy />
      {isCopied ? 'تم نسخ الرابط ✓' : 'نسخ رابط التسجيل'}
    </button>

    <button
      type="button"
      className="home-button"
      onClick={() => window.location.href = homePage}
    >
      <FiHome/>
      العودة للرئيسية
    </button>
  </div>
) : (
  <Message messageType="success" messageText={successMessage} />
)}
{terms && !isCustomerSubmitted && (
  <div className="terms-consent">
    <label>
      <input
        type="checkbox"
        checked={termsAccepted}
        onChange={(e) => setTermsAccepted(e.target.checked)}
        required={true}
      />

      <span>
        أوافق على{' '}
        <button
          type="button"
          className="terms-link"
          onClick={() => setShowTerms(true)}
        >
          الشروط والأحكام
        </button>
      </span>
    </label>
  </div>
)}
        {isLoading && <Message messageType="loading" messageText="جاري التحميل..." />}
        { !(isCustomerSubmitted)  && (
  <button type="submit" disabled={isLoading}>
    {isLoading ? 'جاري الإرسال...' : 'إرسال'}
  </button>
)}
      </form>
      {terms && showTerms && (
  <div
    className="terms-modal-overlay"
    onClick={() => setShowTerms(false)}
  >
    <div
      className="terms-modal"
      onClick={(e) => e.stopPropagation()}
    >
      <button
        type="button"
        className="terms-modal-close"
        onClick={() => setShowTerms(false)}
      >
        ×
      </button>

      <h2>{terms.title}</h2>

      <div className="terms-modal-content">
        {terms.sections.map((section, sectionIndex) => (
          <div key={sectionIndex}>
            {section.title && <h3>{section.title}</h3>}

            {section.items && (
              <ul>
                {section.items.map((item, itemIndex) => (
                  <li key={itemIndex}>{item}</li>
                ))}
              </ul>
            )}

            {section.prizes &&
              section.prizes.map((prize, prizeIndex) => (
                <div key={prizeIndex} className="terms-prize">
                  <h4>{prize.title}</h4>

                  <ul>
                    {prize.items.map((item, itemIndex) => (
                      <li key={itemIndex}>{item}</li>
                    ))}
                  </ul>
                </div>
              ))}
          </div>
        ))}
      </div>
    </div>
  </div>
)}
    </div>
  );
};

export default DynamicForm;
